// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"2256bea8","540":"8f77a86a","957":"2256bea8"}[chunkId] + ".chunk.css";
};